import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { formatMoney } from 'accounting';
import {
  getSales,
  getAcquisitions,
  getSortedSummaryData,
  getSummaryChartData,
} from '../../../redux/selectors/transactions';

import { contactsById } from '../../../redux/selectors/contacts';
import SalesTable from './SalesTable';
import Transaction from '../../../models/Transaction';
import Contact from '../../../models/Contact';
import Loading from '../../common/Loading';
import pageWrapper from '../../containers/MainPage';
import { fetchTransactions, fetchFinances } from '../../../redux/ducks/transactions';
import { fetchContacts } from '../../../redux/ducks/contacts';
import FinanceSummaryData from '../../../models/FinanceSummaryData';
import SummaryTable from './SummaryTable';
import ValuesChart from './ValuesChart';


import './FinancialsPage.css';

class FinancialsPage extends React.Component {
  componentDidMount() {
    const { fetchedTxs, fetchedCts, getData } = this.props;

    if (!fetchedTxs || !fetchedCts) {
      getData();
    }
  }

  render() {
    const {
      isFetchingTxs,
      fetchedTxs,
      isFetchingCts,
      fetchedCts,
      sales,
      acquisitions,
      summaryData,
      contacts,
    } = this.props;

    if (isFetchingTxs || !fetchedTxs || isFetchingCts || !fetchedCts) {
      return <Loading />;
    }

    const valueTooltip = ({ data, value }) => (
      <span>
        {data.category}<br />
        {formatMoney(value, '$', 0)}<br />
        {data.percentage} %
      </span>
    );

    return (
      <div className="financials">
        <div className="financials-summary">
          <SummaryTable summaryData={summaryData} header="Overview" />
        </div>
        <div className="financials-chart">
          <h3 className="subtitle has-text-centered is-4">Average Market Value</h3>
          <ValuesChart
            data={this.props.summaryChartData}
            tooltipTextFn={valueTooltip}
          />
        </div>
        <div className="financials-sales">
          <SalesTable transactions={sales} contacts={contacts} showGainLoss header="Sales" />
        </div>
        <div className="financials-acquisitions">
          <SalesTable transactions={acquisitions} contacts={contacts} header="Acquisitions" />
        </div>
      </div>
    );
  }
}

FinancialsPage.propTypes = {
  sales: PropTypes.arrayOf(PropTypes.instanceOf(Transaction)),
  acquisitions: PropTypes.arrayOf(PropTypes.instanceOf(Transaction)),
  summaryData: PropTypes.arrayOf(PropTypes.instanceOf(FinanceSummaryData)),
  // eslint-disable-next-line react/forbid-prop-types
  summaryChartData: PropTypes.array,
  contacts: PropTypes.objectOf(PropTypes.instanceOf(Contact)),
  isFetchingTxs: PropTypes.bool.isRequired,
  fetchedTxs: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.bool]),
  isFetchingCts: PropTypes.bool.isRequired,
  fetchedCts: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.bool]),
  getData: PropTypes.func.isRequired,
};

FinancialsPage.defaultProps = {
  sales: [],
  acquisitions: [],
  summaryData: [],
  summaryChartData: [],
  contacts: {},
  fetchedTxs: false,
  fetchedCts: false,
};

function mapStateToProps(state) {
  const sales = getSales(state);
  const acquisitions = getAcquisitions(state);
  const contacts = contactsById(state);
  const summaryData = getSortedSummaryData(state);
  const summaryChartData = getSummaryChartData(state);

  const {
    transactions: { isFetching: isFetchingTxs, fetched: fetchedTxs },
    contacts: { isFetching: isFetchingCts, fetched: fetchedCts },
  } = state;

  return {
    sales,
    acquisitions,
    contacts,
    summaryData,
    summaryChartData,
    isFetchingTxs,
    fetchedTxs,
    isFetchingCts,
    fetchedCts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getData: () => {
      dispatch(fetchTransactions());
      dispatch(fetchFinances());
      dispatch(fetchContacts());
    },
  };
}

export default pageWrapper(
  connect(mapStateToProps, mapDispatchToProps)(FinancialsPage),
  'Financials'
);



// WEBPACK FOOTER //
// ./src/components/pages/financials/FinancialsPage.jsx